import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Checkout from "./pages/Checkout";
import Terms from "./pages/legal/Terms";
import Refund from "./pages/legal/Refund";
import Shipping from "./pages/legal/Shipping";
import Cancellation from "./pages/legal/Cancellation";
import Privacy from "./pages/legal/Privacy";
import Return from "./pages/legal/Return";
import GuidePage from "./pages/GuidePage";
import GuideSuccess from "./pages/GuideSuccess";
import { Toaster } from "./components/ui/sonner";
import { Toaster as FormToaster } from "./components/ui/toaster";
import { I18nProvider } from "./i18n";
import CookieConsent from "./components/CookieConsent";
import { ScrollProgress } from "./components/motion";

// New route: start at the top (unless jumping to an #anchor) and fade the page in.
const RouteShell = ({ children }) => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    const id = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 120);
    return () => clearTimeout(id);
  }, [pathname, hash]);
  return (
    <div key={pathname} className="page-in">
      {children}
    </div>
  );
};

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollProgress />
          <RouteShell>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/refund-policy" element={<Refund />} />
              <Route path="/return-policy" element={<Return />} />
              <Route path="/shipping-policy" element={<Shipping />} />
              <Route path="/cancellation-policy" element={<Cancellation />} />
              <Route path="/privacy-policy" element={<Privacy />} />
              <Route path="/guide" element={<GuidePage />} />
              <Route path="/guide/success" element={<GuideSuccess />} />
              <Route path="/download" element={<GuideSuccess />} />
            </Routes>
          </RouteShell>
          <CookieConsent />
        </BrowserRouter>
        <Toaster />
        {/* Renders useToast() messages from the contact and checkout forms */}
        <FormToaster />
      </div>
    </I18nProvider>
  );
}

export default App;
